import React, { createContext, useContext, useEffect } from "react";

/**
 * Verixa is permanently dark.
 * The theme provider is kept (so existing consumers still work)
 * but always returns "dark" and the toggle is a no-op.
 */
const ThemeCtx = createContext({ theme: "dark", toggle: () => {} });

export function ThemeProvider({ children }) {
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.setAttribute("data-theme", "dark");
    document.body.setAttribute("data-theme", "dark");
    try {
      localStorage.setItem("verixa_theme", "dark");
      // remove legacy key
      localStorage.removeItem("tb_theme");
    } catch (_) {}
  }, []);

  return (
    <ThemeCtx.Provider value={{ theme: "dark", toggle: () => {} }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeCtx);
}
